import { BadRequestError } from "./bad-request-error";

// Thrown when a push-token registration presents a string no Expo device produced. The client once
// sent the *error message* of a failed token fetch as if it were the token, and the silent server-
// side skip made that invisible for months — so a refused token is answered as a refusal, never
// absorbed as a success. 400: the payload itself is the problem, and the refusal is what keeps a
// client's failed token fetch from being recorded as a success and cached as one.
export class InvalidPushTokenError extends BadRequestError {
	constructor() {
		super("profile.invalid_push_token");
		this.name = "InvalidPushTokenError";
	}
}
